import { Box, ListView } from '@razorpay/blade/components';
import React from 'react';
import { PerquisitesDetailView, PerquisitesListView } from './index';
import { PerquisitesFilters } from 'components/SalaryComponents/components/filters';
import { PerquisitesDummyData } from 'components/SalaryComponents/__tests__/data';
import { StatusFilterKeyType } from 'components/SalaryComponents/components/filters/StatusFilter';

const PerquisitesView = () => {
  // Using dummy data instead of API
  const data = PerquisitesDummyData;
  const isLoading = false;
  const isRefreshing = false;
  const isError = false;

  // Calculate counts directly in the parent
  const counts: Record<StatusFilterKeyType, number> = {
    all: data.length,
    active: data.filter((node) => node.isActive).length,
    disabled: data.filter((node) => !node.isActive).length,
  };

  return (
    <Box paddingX="spacing.8" marginTop="spacing.5">
      <ListView>
        <PerquisitesFilters counts={counts} />
        <PerquisitesListView
          data={data}
          isLoading={isLoading}
          isRefreshing={isRefreshing}
          isError={isError}
        />
      </ListView>
      <PerquisitesDetailView />
    </Box>
  );
};

export default PerquisitesView;
